'use strict';

var React = require('react');

var SvgThumbsDownMinor = function SvgThumbsDownMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.315 14a4 4 0 0 0-.911 1.193l-.695 1.39a2.563 2.563 0 0 1-2.293 1.417h-.709a1.707 1.707 0 0 1-1.707-1.707v-2.293h-1.405a3 3 0 0 1-2.952-3.537l.91-5a3 3 0 0 1 2.949-2.463h2.094a4 4 0 0 1 2.499.877l2.655 2.123h2.25a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2.685Zm-3.9 2h-.415v-4h-3.405a1 1 0 0 1-.984-1.179l.909-5a1 1 0 0 1 .984-.821h2.093a2 2 0 0 1 1.25.438l3.153 2.523v3.814a6 6 0 0 0-2.385 2.523l-.695 1.39a.563.563 0 0 1-.504.312Z"
  }));
};

exports.SvgThumbsDownMinor = SvgThumbsDownMinor;
